import type StatusObject from '@/classes/SubmissionStatuses/StatusObject'
import { StatusThemeVariant } from '@/classes/SubmissionStatuses/StatusThemeVariantEnum'
import { type SubmissionAction } from '@/classes/SubmissionStatuses/types'
import { DateTime } from 'luxon'

export class NoneSentStatus implements StatusObject {
	vendorName: string
	constructor(vendorName: string) {
		this.vendorName = vendorName
	}
	getVendorName(): string {
		return this.vendorName
	}
	getUpdatedAt() {
		return DateTime.now().toISODate()
	}

	getActions(): Array<SubmissionAction> {
		return []
	}

	getStatusText() {
		return 'None Sent'
	}

	getToolTipText() {
		return {
			title: 'None Sent',
			body: "There is no record of this vendor's documents being submitted. If you believe this is an error, please contact salesstudio@precoa.com.",
		}
	}

	getThemeVariant() {
		return StatusThemeVariant.INACTIVE
	}
}
